import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PaymentItem } from "../components/PaymentMethods";

export interface PayablePaymentSummaryState {
  id?: number;
  supplierId?: number;
  supplier?: string;
  number?: string;
  total?: number;
  paid?: number;
  balance?: number;
  status?: string;
}

interface PayablePaymentState {
  summary: PayablePaymentSummaryState | null;

  paymentDate: string;
  notes: string;
  payments: PaymentItem[];
}

const initialState: PayablePaymentState = {
  summary: null,

  paymentDate: new Date().toISOString().split("T")[0],
  notes: "",
  payments: [],
};

const PayablePaymentSlice = createSlice({
  name: "payablePayment",
  initialState,

  reducers: {
    /**
     * 🔹 Cargar resumen inicial desde backend
     */
    setPaymentSummary(
      state,
      action: PayloadAction<PayablePaymentSummaryState>
    ) {
      state.summary = action.payload;
    },

    /**
     * 🔥 Actualizar resumen después de aplicar pago
     */
    updatePaymentSummary(
      state,
      action: PayloadAction<{
        paidAmount: number;
        balance: number;
        status: string;
      }>
    ) {
      if (!state.summary) return;

      state.summary = {
        ...state.summary,
        paid: action.payload.paidAmount,
        balance: action.payload.balance,
        status: action.payload.status,
      };
    },

    /**
     * 📅 Fecha de pago
     */
    setPaymentDate(
      state,
      action: PayloadAction<string>
    ) {
      state.paymentDate = action.payload;
    },

    /**
     * 📝 Notas
     */
    setNotes(
      state,
      action: PayloadAction<string>
    ) {
      state.notes = action.payload;
    },

    /**
     * 💳 Métodos de pago
     */
    setPayments(
      state,
      action: PayloadAction<PaymentItem[]>
    ) {
      state.payments = action.payload;
    },

     /**
     * 🔥 Limpiar pagos + notas después de registrar
     */
    resetPaymentDetails(state) {
      state.notes = "";
      state.payments = [];
      state.paymentDate = new Date()
        .toISOString()
        .split("T")[0];
    },

    /**
     * 🧹 Reset completo del formulario
     */
    resetPayablePaymentForm() {
      return initialState;
    },
  },
});

export const {
  setPaymentSummary,
  updatePaymentSummary,
  setPaymentDate,
  setNotes,
  setPayments,
  resetPaymentDetails,
  resetPayablePaymentForm,
} = PayablePaymentSlice.actions;

export default PayablePaymentSlice.reducer;